/**
 * Reproduce un video de forma segura
 */
export function playVideoSafely(videoElement: HTMLVideoElement, videoSelector: string): void {
    // Asegurar que el video esté muted para autoplay
    videoElement.muted = true;

    videoElement.play().then(() => {
        console.log(`✅ Video ${videoSelector} reproduciendo`);
    }).catch(error => {
        console.error(`❌ Error reproduciendo video ${videoSelector}:`, error);

        // Intentar cargar el video de nuevo
        videoElement.load();
        setTimeout(() => {
            videoElement.play().catch(e => {
                console.error(`❌ Segundo intento fallido para ${videoSelector}:`, e);
            });
        }, 1000);
    });
}

/**
 * Pausa todos los videos
 */
export function pauseVideo(): void {
    const videoSelectors = ['#videoInitial', '#videoAuthentication', '#videoIDV', '#videoOnboarding'];

    videoSelectors.forEach(selector => {
        const video = document.querySelector(selector) as HTMLVideoElement;
        if (video) {
            try {
                video.pause();
            } catch (error) {
                console.warn(`Error al pausar video ${selector}:`, error);
            }
        }
    });
}
